import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GenericDocLockContainerModel } from "../../../../../../models/aggregates/generic_doc";
import { GenericDocEditingLockDto } from "../../../data-transfer-objects";
import { ApiResponseModel, ApiVisa, BasicApiResponseModel } from "../../shared";
import { BaseApiTemplateService } from "../../shared/base-api-template-service.model";
import { Core2Config } from "../../shared/core2Config";

@Injectable({ providedIn: "root" })
export class GenericDocLockService extends BaseApiTemplateService<GenericDocLockContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "generic-doc/editing-blocks";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "generic-doc/editing-blocks";
    this.httpClient = http;
  }

  public checkDocument(
    dtoObject: GenericDocEditingLockDto,
    visa: ApiVisa
  ): Observable<ApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.post<BasicApiResponseModel<any>>(
      this.apiUrl + "/backoffice-ep",
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public unblockDocument(
    dtoObject: GenericDocEditingLockDto,
    visa: ApiVisa
  ): Observable<ApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.post<BasicApiResponseModel<any>>(
      this.apiUrl + "/unblock/backoffice-ep",
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}
